import React from 'react'
import { StyleSheet } from 'aphrodite'

import Layout from '../../components/Layout'
import ExpenseCreate from './expense-create'
import { useModal } from '../../hooks/modal'
import { useLoad } from '../../hooks/request'
import { EXPENSE_REPORT_LIST, INCOME_LIST } from '../../urls'
import IncomeDetailTable from '../../components/IncomeDetailTable'

export default function Expenses() {
    const expenseReport = useLoad({ url: EXPENSE_REPORT_LIST })

    const [showCreateModal, setShowCreateModal] = useModal(<ExpenseCreate expenseReport={expenseReport} onCancel={() => setShowCreateModal()} />, styles.modal)

    const categories = useLoad({ url: INCOME_LIST })

    return (
        <Layout showCreateModal={showCreateModal}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {(categories.response ? categories.response.results : []).map((category) => (
                    <IncomeDetailTable incomeId={category?.id} category={category} />
                ))}
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({ modal: { width: 800 } })
